import { makeStyles, Theme } from '@material-ui/core/styles';
import { pink } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    position: 'fixed',
    width: 470,
    height: 300,
    bottom: 24,
    right: 24,
    padding: 30,
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    borderRadius: '2px',
    boxShadow: '0 24px 24px 0 rgba(0, 0, 0, 0.3), 0 0 24px 0 rgba(0, 0, 0, 0.22)',
    zIndex: 3,
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.primary,
    opacity: 0.54,
  },
  contentDesc2: {
    fontSize: 11,
    color: '#aaa',
    lineHeight: 1.2,
  },
  buttonWrap: {
    paddingTop: 24,
    marginRight: -4,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cancelButton: {
    marginRight: theme.spacing(1),
  },
  noteWrap: {
    marginTop: 14,
    width: '100%',
    height: 130,
    overflow: 'auto',
  },
  note: {
    fontSize: 14,
    width: '100%',
    lineHeight: 1.1,
    // color: '#a2a2a2',
  },
  submitButtonProgress: {
    color: pink[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default useStyles;
